module.exports = __webpack_public_path__ + "static/media/Kacisdorfske_pole.3355b271.md";